import { render, staticRenderFns } from "./franchise.vue?vue&type=template&id=334059ca&scoped=true"
import script from "./franchise.vue?vue&type=script&lang=js"
export * from "./franchise.vue?vue&type=script&lang=js"
import style0 from "./franchise.vue?vue&type=style&index=0&id=334059ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334059ca",
  null
  
)

export default component.exports